import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CategoriesHttpService } from '../../services/categories.http';
import { Category } from '../../types/event-response.type';
import { NavigationService } from '../../services/navigation.service';
import { AuthService } from '../../services/auth.service';
import { Observable } from 'rxjs';
import { DEFAULT_BANNER_IMAGE } from '../../constants/constants';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent implements OnInit {
  @Input() category: Category;
  @Input() wide = false;
  followControl = new UntypedFormControl(false);

  public user$ = this.authService.user$;

  @ViewChild('unauthorizedUserPopup', { static: true })
  unauthorizedUserPopup: ElementRef;

  constructor(
    private categoriesService: CategoriesHttpService,
    private authService: AuthService,
    private navigation: NavigationService,
    private popupService: PopupService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.followControl.valueChanges.subscribe(() => {
      if (this.authService.user) {
        this.toggleFollow().subscribe();
      } else {
        this.openUnauthorizedUserPopup();
        this.followControl.setValue(false, {
          emitEvent: false,
        });
      }
    });
    this.user$.subscribe((user) => {
      this.followControl.setValue(
        Boolean(
          user?.follows.categories.find(
            (category) => category.category_id === this.category.category_id
          )
        ),
        { emitEvent: false }
      );
      this.cdr.detectChanges();
    });
  }

  searchByCategory(event: Event, category_id: number): void {
    event.stopPropagation();
    this.navigation.goToResultsByCategoryId([category_id]);
  }

  openSubcategory(event: Event, category_id: number): void {
    event.stopPropagation();
    this.navigation.goToCategoriesPage(category_id);
  }

  toggleFollow(): Observable<Object> {
    return this.categoriesService.followCategory(this.category.category_id);
  }

  get categoryLogoImage(): string {
    if (this.category.logo_image) {
      return this.category.logo_image;
    }

    return DEFAULT_BANNER_IMAGE;
  }

  get dynamicStyles(): Record<string, string> {
    return {
      'background-image': `url(${this.categoryLogoImage})`,
    };
  }

  openUnauthorizedUserPopup(): void {
    this.popupService.showPopup(this.unauthorizedUserPopup);
  }
}
